<template>
  <div class="d-flex justify-center align-center">
    <div
      class="loader"
      :style="
        loader
          ? 'display: block !important; width: 70%;'
          : 'display: none !important;'
      "
    >
      <v-card
        :color="socio ? socio.cor : '#39424e'"
        max-width="200px"
        class="pa-4 ma-auto"
      >
        <v-img
          class="mb-4 ma-auto"
          :src="socio ? socio.logo : '../../../assets/logo.svg'"
          contain
          max-width="60"
        ></v-img>
        <div style="width: 90%; margin: auto">
          <v-progress-linear indeterminate color="#00c7ba"></v-progress-linear>
        </div>
      </v-card>
    </div>
    <v-card
      :class="loader ? 'main-card-loader ma-2' : 'main-card ma-2'"
      elevation="20"
      min-height="720"
      max-width="1200"
    >
      <Drawer :step="step" :socio="socio" />

      <div class="pl-6 d-flex justify-center align-center content">
        <v-window v-model="step" touchless>
          <v-window-item>
            <PessoalInfo :socio="socio" @save="save" />
          </v-window-item>

          <v-window-item>
            <v-btn
              style="color: var(--custom-primary-color)"
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <Results
              :key="key"
              :result="model"
              :socio="socio"
              @selectItem="select"
              @stop="stopLoader"
            />
          </v-window-item>

          <v-window-item>
            <v-btn
              style="color: var(--custom-primary-color)"
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <FinalSimulation
              :selectedItem="selectedItem"
              :user="model"
              :socio="socio"
              @confirm="next"
            />
          </v-window-item>

          <v-window-item>
            <v-btn
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
              style="color: var(--custom-primary-color)"
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <Proposal @confirm="next" :socio="socio" />
          </v-window-item>

          <v-window-item>
            <v-btn
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
              style="color: var(--custom-primary-color)"
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <DPS @confirm="next" :socio="socio" />
          </v-window-item>

          <v-window-item>
            <Final :selectedItem="selectedItem" :user="model" />
          </v-window-item>
        </v-window>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.main-card {
  display: flex;
  border-radius: 25px !important;
  background: #ffffff;
}

.main-card-loader {
  display: flex;
  border-radius: 25px !important;
  filter: blur(35px) !important;
}

.content {
  max-width: 70%;
}

.loader {
  position: absolute;
  top: 300px;
  left: 200px;
  z-index: 100;
}

@media (max-width: 960px) {
  .main-card {
    flex-direction: column-reverse;
  }
  .content {
    max-width: unset;
  }
}
</style>

<script>
import Drawer from "./components/drawer.vue";
import PessoalInfo from "./components/pessoalInfo.vue";
import Results from "./components/results.vue";
import FinalSimulation from "./components/finalSimulation.vue";
import Final from "./components/final.vue";
import Proposal from "./components/proposal.vue";
import DPS from "./components/dps.vue";
import ApiService from "../../../services/ApiService";
import axios from "axios";
export default {
  name: "Home",

  data: () => ({
    model: {},
    key: false,
    step: 0,
    selectedItem: null,
    socio: null,
    apiService: new ApiService(),
    loader: true,
  }),

  components: {
    Drawer,
    PessoalInfo,
    Results,
    FinalSimulation,
    Final,
    DPS,
    Proposal,
  },

  async created() {
    await this.getLogoParceiroAsync();
    this.createRootElement();
    this.$root.$on("stop", () => {
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    });
  },

  methods: {
    save(model) {
      this.model = model;
      this.key = !this.key;
      this.loader = true;
      this.next();
    },

    next() {
      if (this.step < 5) {
        this.step++;
      }
    },

    back() {
      if (this.step > 1) {
        this.step--;
      }
    },

    select(item) {
      this.selectedItem = item;
      this.next();
    },

    stopLoader() {
      this.loader = false;
    },

    async getLogoParceiroAsync() {
      if (this.$route.query.pc) {
        localStorage.setItem("queryInfos", JSON.stringify(this.$route.query));
        await axios
          .get(
            `https://globusesteiraback.azurewebsites.net/api/loja/get-logo-by-lojaId?lojaId=${this.$route.query.loja}&id_parceiro=${this.$route.query.pc}&cpf_corretor=${this.$route.query.pf}&id_produto=vida_individual_simples`
          )
          .then((response) => {
            this.socio = { ...response.data };
            localStorage.setItem("sessionId", response.data.clickId);
            localStorage.setItem(
              "queryInfos",
              JSON.stringify({
                ...this.$route.query,
                emailSocio: this.socio.emailSocio,
              })
            );
            this.$store.commit("SET_SOCIO", this.socio);
            this.$vuetify.theme.primary = this.socio.cor;
            const favicon = document.getElementById("faviconVida");
            favicon.setAttribute("href", this.socio.icon);
          })
          .catch((error) => {});
      } else {
        this.socio = null;
      }
      this.loader = false;
    },
    createRootElement() {
      const styleElement = document.createElement("style");
      styleElement.textContent = `:root { 
      --custom-total-primary-color: ${this.socio ? this.socio.cor : "#00C7BA"};
      --custom-primary-color: ${this.socio ? this.socio.cor : "#00C7BA"};
      --custom-white-color: ${
        this.socio ? this.getContrastColor(this.socio.cor) : "#00C7BA"
      };
      --custom-white-second-color: ${
        this.socio ? this.getContrastColor(this.socio.cor) : "#fff"
      };
      --custom-second-color: ${this.socio ? this.socio.cor : "#39424e"};
     }`;
      document.head.appendChild(styleElement);
      if (this.socio) {
        this.$store.commit(
          "SET_COLOR_DARK_OR_LIGHT",
          this.getContrastColor(this.socio.cor)
        );
      } else {
        this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#00C7BA");
      }
    },
    getContrastColor(hexColor) {
      const r = parseInt(hexColor.substring(1, 3), 16);
      const g = parseInt(hexColor.substring(3, 5), 16);
      const b = parseInt(hexColor.substring(5, 7), 16);

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 125 ? "#013" : "#fff";
    },
  },
};
</script>
